import React from 'react';
import { Form, FormFeedback, Input, Modal } from 'reactstrap';
import { BaseCustomButton, GradientDecorationLine, BaseCustomModal } from '../../../../shared';

// Formik validation
import { useFormik } from "formik";
import moment from 'moment';
import * as Yup from "yup";

export const EditDatePartialReportModal = ({ props, setShowModal, showModal, modalHeader, modalClose, modalRespInfo, rowInfo }) => {


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            deliveryDatedAt: rowInfo?.deliveryDatedAt ? (moment.utc(rowInfo.deliveryDatedAt).format('YYYY-MM-DD')) : moment(new Date()).format('YYYY-MM-DD'),
            supportedDocumentation: rowInfo?.supportedDocumentation ? rowInfo.supportedDocumentation : '',
        },
        validationSchema: Yup.object({
          deliveryDatedAt: Yup.string().required("Ingrese la fecha"),
          supportedDocumentation: Yup.string().required("Ingrese la documentación"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values)
            resetForm()
            setShowModal(false)
            // dispatch(loginUser(values, props.history));
        }
    });

    const { className } = props;
    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () =>{
        validation.resetForm();
        modalClose();
    }

    const title = (
        <div className=' d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>{modalHeader}</h4></label>
        </div>
    )

    const footerButtons = (
        <div className="page-title-box d-flex justify-content-end">
          <BaseCustomButton
            color="success"
            outline
            className="rounded-3 me-2"
            onClick={validation.handleSubmit}
            label="Guardar"
            icon="mdi mdi-content-save me-1"
          />
          <BaseCustomButton
            color="danger"
            outline
            className="rounded-3 me-2"
            onClick={toggle}
            label="Cancelar"
            icon="mdi mdi-close-circle-outline me-1"
          />
        </div>
    );

    return (
        <BaseCustomModal
          title={title}
          isModalOpen={showModal}
          handleCancel={toggle}
          handleOk={validation.handleSubmit}
          className={className}
          footer={footerButtons}
          onClosed={onClosed}
        >
          <GradientDecorationLine />
    
          <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="row mx-4 my-3">
              <div className="col-3 col-md-12">
                <label className="text-primary ml-1">
                  Fecha de Entrega de Informe {moment(new Date()).format('YYYY-MM-DD')}
                </label>
                <div className="w-100 me-3">
                  <Input
                    required
                    name="deliveryDatedAt"
                    className="form-control rounded-3 text-primary"
                    disabled={true}
                    type="date"
                    value={moment(new Date()).format('YYYY-MM-DD')}
                    onBlur={validation.handleBlur}
                  />
                </div>
              </div>
            </div>
    
            <div className="row mx-4 my-3">
              <div className="col-3 col-md-12">
                <label className="text-primary">Documentación Soporte</label>
                <Input
                  required
                  name="supportedDocumentation"
                  className="form-control text-primary"
                  placeholder="Documentación Soporte"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.supportedDocumentation || ""}
                  invalid={
                    validation.touched.supportedDocumentation &&
                    !!validation.errors.supportedDocumentation
                  }
                />
                {validation.touched.supportedDocumentation && validation.errors.supportedDocumentation && (
                  <FormFeedback type="invalid">
                    {validation.errors.supportedDocumentation}
                  </FormFeedback>
                )}
              </div>
            </div>
    
            <div className="mt-5">
              <GradientDecorationLine />
            </div>
          </Form>
        </BaseCustomModal>
      );
    };